const yiq = (color: string | null | undefined) => {
	if (!color) return Number.NaN;

	const col = color.replace('#', '');
	const red = parseInt(col.slice(0, 2), 16);
	const green = parseInt(col.slice(2, 4), 16);
	const blue = parseInt(col.slice(4, 6), 16);
	return (red * 299 + green * 587 + blue * 114) / 1000;
};

export const findContrastingColor = <L, D>(color: string | null | undefined, lightColor: L, darkColor: D) => {
	const contrast = yiq(color);

	if (Number.isNaN(contrast) || contrast > 127) {
		return darkColor;
	} else {
		return lightColor;
	}
};
